import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitleCommon, {DialogCloseCommon} from "./DialogTitleCommon";
import DialogContent from "@mui/material/DialogContent";
import {Alerts, PageNames} from "commonUtils/enumerations";
import {dashBoardMessageStyle} from "features/Dashboard/components/DashboardMessages/dashBoardMesssageStyle";
import type {MessageListDialogProps} from "features/Dashboard/components/DashboardMessages/dashBoardMesssageStyle";
import Box from "@mui/material/Box";
import FormValidationAlert from "components/FormComponents/Alert/FormValidationAlert";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import type {SelectChangeEvent} from "@mui/material/Select";
import {
  firstFiveYears,
  handleAxiosErrors,
  isValidObject,
  loggedMessage,
} from "commonUtils/utils";
import MenuItem from "@mui/material/MenuItem";
import {postRequest, setHeader} from "repository/genericRepository";
import {store} from "../../redux/store";
import {ANNOUNCEMENT_VIEW_ALL_ENDPOINT} from "commonUtils/globalAPISettings";
import CommonDataGrid from "components/Grids/CommonDataGrid";

const MessageListDialog = ({
  listMessageDialog,
  viewAllRecords,
  setViewAllRecords,
  showAlert,
  setShowAlert,
  serverValidation,
  setServerValidation,
  setListMessageDialogOpen,
  columns,
  loader,
  setLoader,
  messageYear,
  setMessageYear,
  dialogRef,
}: MessageListDialogProps) => {
  const handleYearChange = async (event?: SelectChangeEvent<number>) => {
    try {
      setMessageYear(event?.target?.value as number);
      const authState = store.getState();
      const APIHeaders = {
        Authorization: `Bearer ${authState.auth?.authDetails?.token}`,
      };
      const announcementKey = 0;
      const profileID = authState.auth?.userDetails?.profileId;
      const announcementYear = event?.target?.value;
      setLoader(true);
      const responseData = await postRequest({
        url: ANNOUNCEMENT_VIEW_ALL_ENDPOINT,
        headers: setHeader(APIHeaders),
        params: {announcementKey, profileID, announcementYear},
      });
      if (isValidObject(responseData)) {
        setViewAllRecords(responseData.announcements);
      }
      setLoader(false);
    } catch (error: any) {
      loggedMessage(error, serverValidation?.message, PageNames.DASHBOARD);
      handleAxiosErrors(error, setShowAlert, setServerValidation);
      setLoader(false);
    }
  };

  return (
    <Dialog
      PaperProps={{
        sx: dashBoardMessageStyle.paperPropUDialog,
      }}
      open={listMessageDialog}>
      <DialogTitleCommon title="List of Messages" />
      <DialogCloseCommon
        onClick={() => {
          setListMessageDialogOpen(false);
        }}
      />
      <DialogContent ref={dialogRef}>
        {viewAllRecords && (
          <Box sx={{minHeight: "35rem"}}>
            {showAlert && serverValidation?.message && (
              <Box mb={"1rem"}>
                <FormValidationAlert
                  closeIcon={true}
                  showAlertBox={showAlert}
                  setShowAlertBox={setShowAlert}
                  severity={
                    (serverValidation?.isSuccessMessage ?? false)
                      ? Alerts.SUCCESS
                      : (serverValidation?.isValidationMessage ?? false)
                        ? Alerts.INFO
                        : Alerts.ERROR
                  }
                  message={serverValidation?.message}
                />
              </Box>
            )}

            <Box display={"flex"} justifyContent={"end"}>
              <FormControl
                sx={{
                  mb: 1,
                  minWidth: 80,
                }}
                size="small">
                <Select
                  sx={{height: "2rem"}}
                  value={messageYear}
                  onChange={event => {
                    handleYearChange(event);
                  }}>
                  {firstFiveYears.map((year: string, i: number) => (
                    <MenuItem className="main-font-family" key={i} value={year}>
                      {year}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <CommonDataGrid
              getRowHeight={() => "auto"}
              sx={dashBoardMessageStyle.dataGridStyle}
              getRowId={row => row?.announcementKey}
              viewAllRecords={viewAllRecords}
              columns={columns}
              hideFooter={true}
              loader={loader}
            />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default MessageListDialog;
